import React,{ Component } from 'react';

import './LiveMissions.css';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';

import { API_URL } from '../../../../utils/config';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import CSVTable from '../../../../components/CSVTable/CSVTable';
import request from '@acri-tools/react-tools/utils/request';
import { get_data_file_url } from '../../../../utils/data';

interface Props{
}
interface State{
    loading: boolean

    data?:any
}

export default class LiveMissions extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state={
            loading: false,
        }
    }

    componentDidMount(){
        this.fetch_data()
    }


    fetch_data = async() =>{
        this.setState({ loading: true });
        try{
            let res = await request(get_data_file_url(`archive_content_dataset_list_lm.csv`),{
                method: 'get'
            })

            this.setState({ data: res.data });
        }
        catch(e:any){
            axiosErrorHandler(e, { functionName: `fetch_data` });
            toast_request_error(e);
        }
        finally{
            this.setState({ loading: false })
        } 
    }

    render(){
        return (
            <div className="live-missions">
                {
                    this.state.loading ?
                        <div className="centered">
                            <Spinner/>
                        </div>
                    :
                    this.state.data &&
                    <CSVTable
                        update_filter
                        export export_name="live_mission_products_list"
                        data={this.state.data}
                        parse_options={{
                            delimiter: ";"
                        }}
                        filters={[
                            { index: 0, label:<><i className="fas fa-satellite"/> Missions</> },
                            { index: 1, label:<><i className="fas fa-drafting-compass"/> Instruments</> },
                            { index: 2, label:<><i className="fas fa-cogs"/> Product Types</>}
                        ]}
                        sort_columns={{
                            0: { filter: 'alphabetical' },
                            1: { filter: 'alphabetical' },
                            2: { filter: 'alphabetical' },
                            3: { filter: 'numerical' },
                            4: { filter: 'numerical' },
                        }}
                    />
                }
            </div>
        );
    }
    
};
